import(/* webpackMode: "eager" */ "/codebuild/output/src2168388147/src/apps/web/app/[locale]/error.tsx");
